/*
 * PluginSelectionHeader2ndStep Messages
 *
 * This contains all the text for the PluginSelectionHeader2ndStep component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.components.PluginSelectionModal.PluginSelectionHeader2ndStep';

export default defineMessages({
  backButton: {
    id: `${scope}.backButton`,
    defaultMessage: 'Back',
  },
});
